import * as sonbp from "sonbp";
import * as ifbase from "../../base";
import * as tool from "../../tool";
import { drawCommon } from "../drawCommon";
import { poscaPickupEditor } from "./poscaPickupEditor";
import { poscaVitem } from "./poscaVitem";

/**
* ポスカ用スタンプのコンテンツエディター
* @summary ハンドル操作をピックアップで処理するように拡張しています。
*/
export class poscaStampEditor extends poscaPickupEditor {

	// -----------------------------------------------
	// Constructors（コンストラクタ）
	// -----------------------------------------------

	/**
	 * コンストラクタ
	 */
	public constructor(ifdto: ifbase.ifDto) {
		super(ifdto);
	}

	// -----------------------------------------------
	// Methods（外部アクセス用メソッド）
	// -----------------------------------------------

	/**
	 * 処理取得
	 * @override
	 */
	public take(select: sonbp.type.select): boolean {

		let p = super.take(select);

		let notake = (): boolean => {
			this._v._lm.unsetPickUpper(this);
			return false;
		}

		if (!p) return notake();

		if (!ifbase.util.chkIsStamp(select.items[0])) return notake();

		// 編集データ取得
		this._vitem = new poscaVitem(this._select.items[0]);

		//ピックアップ
		this._v._dm.pickDraw();
		this._v._lm.setPickUpper(this, this._select.items[0]);

		this.init();
		return true;
	}

	// -----------------------
	// 描画機能 関数
	// -----------------------

	/**
	 * eidtCanvasへの描画
	 * @override
	 */
	public drawPickItem(co: sonbp.draw.editCanvasOperator): void {

		var image = this._select.items[0] as sonbp.object.xobjectItem;

		//画像描画
		co.ctx.save();
		{
			var width = 1, height = 1;
			if (image.subtype == sonbp.constant.itemSubType.FORM) width = image.size[0], height = image.size[1];

			var imgData = this._v._cm.getImg(image.src, image._apply_pageIdx, image._apply_layerIdx);
			var matrix = this._vitem.apply_matrix;

			co.ctx.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
			co.ctx.save();
			co.ctx.transform(1, 0, 0, -1, 0, height);
			co.ctx.drawImage(imgData.img, 0, 0, imgData.img.width, imgData.img.height, 0, 0, width, height);
			co.ctx.restore();
		}
		co.ctx.restore();
	}

	/**
	 * eidtCanvasへの描画
	 * 再編集可能な非選択アイテムすべてに描写（2025年対応：配置済み画像の再編集可能 #28295）
	 */
	protected gdrawEditCanvas(co: sonbp.draw.canvasOperator): void {

		// 選択候補描画
		ifbase.constants.LTYPES_CAN_RESELECT.forEach(layerType => {

			let layer = ifbase.util.getLayer(this._ifdto, layerType).layer;
			let items = layer.items.filter(d => d.id != this._select.items[0].id)
			co.ctx.save();
			{
				drawCommon.drawCandidate(this._ifdto, co.ctx, items);
			}
			co.ctx.restore();
		});
	}

}
